import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router';

export default function ClubesRoute() {
  const { isClubes } = useAuth();
  return isClubes() ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
